_require [
  'swiper'
], ->
  new Swiper('.js-universities-ranking-swiper',
    spaceBetween: 15
    slidesPerView: 1.2
    pagination: {
      el: '.js-swiper-pagination'
    }
  )

  new Swiper('.js-answers-swiper',
    spaceBetween: 30
    navigation: {
      nextEl: '.swiper-button-next'
      prevEl: '.swiper-button-prev'
    }
  )
